import { render, staticRenderFns } from "./SelectorButacas.vue?vue&type=template&id=43471c1c"
import script from "./SelectorButacas.vue?vue&type=script&lang=js"
export * from "./SelectorButacas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports